export default __webpack_public_path__ + "static/media/38_mobile.bcc5b178.jpeg";